var Backbone = require('backbone');


module.exports = Backbone.Model.extend({

    defaults: {

        "id": null,
        "subject": null,
        "stampOptions": null,
        "creationUser": null,
        "creationTime": null,
        "accessGroup": null,
        "blobId": null,
        "type": null,

        "src": null, // base64 image for graphic; text for text
        "imageHeader": null // ( only for graphic stamps )

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/stamp.js
 ** module id = 93
 ** module chunks = 0
 **/